import { useState } from "react";


import ProfileLayout from "../features/Profile/components/ProfileLayout";

export default function Profile() {
 

  return (
     <ProfileLayout />
  );
}